export const PLAY_BY_PLAY = {
  REQUEST_PARAMS: {
    appType: 'appType=5'
  },

  ACTION_TYPES: {
    fetchFeedHandler: 'fetchFeedHandler',
    toggleCollapsed: 'toggleCollapsed',
    displayHandler: 'displayHandler',
    showMoreClick: 'showMoreClick'
  },

  COMPETITORS: {
    home: 1,
    away: 2
  },

  DISPLAY: {
    eventLogoSize : 16,
    entityLogoSize : 24
  },

  MEMBERS_SUBSTITUTION_INDEX: {
    in: 1,
    out: 2
  },

  TYPES: {
    assist: 1,
    info : 7,
    var: 8,
    goal: 14,
    clock : 15,
    penaltyGoal: 24,
    redCard: 35,
    substitution : 37,
    yellowCard : 44,
  },

  ANALYTICS: {
    SOURCE: {
      tab: 'tab',
      preview: 'preview'
    }
  }
}
